"use client";

import { FeaturesByCategoryType, PropertyHighlightType, PropertyTypeV2, StructuredDescriptionType } from "commonModule/services/common";
import { useTrackPdpView } from "./useTrackPdpView";
type PdpViewTrackerProps = {
  property: PropertyTypeV2;
  amenities: FeaturesByCategoryType[];
  propertyhighlights?: PropertyHighlightType[];
  structuredDescription?: StructuredDescriptionType | null;
  isAISummary?: boolean;
  multiUnitGrpId?: string | null;
};
const PdpViewTracker = (props: PdpViewTrackerProps) => {
  useTrackPdpView(props);
  return null;
};
export default PdpViewTracker;